import { Fragment, useState } from 'react'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../parts/crud/List'
import {ActionType, ColumnType, DefaultMenuActions, FilterType} from '../../../parts/crud/Types'
import { Navigate } from 'react-router-dom'


// Tenant	Nome	Email	Telefono	Ruolo	Creato il
export const ListUser = () => {
  const [redirect, setRedirect] = useState("")
 
  const columns: Array<ColumnType> = [
    {title: 'Tenant', key: 'groups', type:'custom', orderable: false, style:{'width':'300px'}, render: (data) => {
      return <>
      {data.groups.map((group: any) => {
        return (
          <Fragment key={group.value}>
          <span key={group.value} className="badge badge-secondary">{group.label}</span> 
          {' '}
          </Fragment>
        )
      
      })}
      </>
    }},
    {title: 'Nome', key: 'name', type: 'text', orderable: true},
    {title: 'Email', key: 'email', type: 'text', orderable: true},
    {title: 'Telefono', key: 'mobile', type: 'text', orderable: true},
    {title: 'Ruolo', key: 'role', type: 'text', orderable: true},
    {title: 'Creato il', key: 'createdDtm', type: 'datetime', orderable: true},
  
  ]
  let actions: ActionType[] = DefaultMenuActions
  let myacttion: ActionType[] = [
    {
      title: 'Log accessi',
      type: 'link',
      action: 'show_log',
      icon: 'fa-solid fa-bars-staggered',
    },
  ]
  actions = [...myacttion, ...actions]

  const filters: Array<FilterType> = [
    {
      title: 'Ruolo',
      key: 'role_id',
      type: 'ajaxselect',
      options: {
        apiPath: 'users/roles',
        valueField: 'roleId',
        labelField: 'role',
        addEmpty: true,
        emptyLabel: 'Mostra tutti gli utenti',
      },
    },
  ]
  return (
    <>
    {redirect !== "" ? <Navigate to={redirect}></Navigate> : <></>}
      <CrudProvider api='users'>
        <ListComponent
          menuClicked={(action, data) => {
            if (action === 'show_log') {
              setRedirect('/user/logs/' + data.id )
              return false
            }
            return true
          }}
          columns={columns}
          actions={actions}
          defOrder='name'
          perPage={20}
          defOrderDir='asc'
          filters={filters}
          title_delete='Eliminazione utente'
          text_eliminare="Sei sicuro di voler eliminare questo utente?L'operazione non è reversibile"
          text_eliminato='Utente eliminato con successo'
          text_nuovo='Nuovo utente'
        />
      </CrudProvider>
    </>
  )
}
